import React from 'react'

import {
  BymaButton,
  BymaCard,
  BymaDataTable,
  BymaExportButton,
  BymaPageFrame,
  BymaTextInputFilter,
  BymaSelect,
} from 'components'

import { ListBase, useListContext, useNotificationProducer, LoadingProvider } from 'core'

import { FiltersHeader } from 'features/common/Filters'

import { useEditButtonCell, useDeleteButtonCell } from 'features/common/Entity'

import { EntityContextInfo, useEntityContext } from 'features/common/Entity'

import { PAIS_ENTITY_NAME, PaisesApi, OrdenPais, OrdenPaisOptions } from 'model/pais'

import PaisModal from './PaisModal'
import { SORT_FILTER_NAME } from 'services/api'

const getPaisColumns = (context: EntityContextInfo) => {
  return [
    {
      field: 'denominacion',
      headerName: 'Denominación FCI/SSN',
      textAlign: 'left',
      minWidth: 350,
    },
    {
      field: 'codigo',
      headerName: 'Código',
      textAlign: 'left',
      minWidth: 150,
    },

    useEditButtonCell({ context, minWidth: 40 }),
    useDeleteButtonCell({ context, minWidth: 40 }),
  ]
}

const PaisTable = () => {
  const { addNotification } = useNotificationProducer()

  const context = useEntityContext(PAIS_ENTITY_NAME, 'Nacionalidad')

  const { filterValues } = useListContext()

  const handleAddEntity = () => {
    context.setEntityId(undefined)
    context.setShowModal(true)
    context.setEditEnabled(true)
  }

  const dataProvider = (params) => PaisesApi.getPaginatedList(params)

  const filters = [
    <BymaTextInputFilter
      name='denominacion'
      key='denominacion'
      label='Denominación Pais'
      type='text'
      alwaysOn={true}
      style={{ width: '300px' }}
      variant='Small'
    />,

    <BymaSelect
      name={SORT_FILTER_NAME}
      key={SORT_FILTER_NAME}
      label='Ordenar'
      style={{ minWidth: '250px' }}
      options={OrdenPaisOptions}
      alwaysOn={true}
      variant='Small'
      hideLabel={true}
    />,
  ]

  return (
    <BymaPageFrame
      bcHome={{ value: 'Administrar', link: '/home' }}
      bcItems={[]}
      bcActive='ABM FCI/SSN'
      showTitle={false}
      showToast={true}
    >
      <BymaCard key={'inversores-card'} header={{ title: 'Nacionalidades' }}>
        <div style={{ paddingBottom: '1%', paddingTop: '2%' }}>
          <FiltersHeader
            filters={filters}
            showFiltersMenu={false}
            extra={[
              <BymaButton
                type='button'
                id='inversores-add-btn'
                key='inversores-add-btn'
                name='inversores-add-btn'
                label={'+ Nueva Nacionalidad'}
                onClick={handleAddEntity}
              />,
            ]}
            exportButton={
              <BymaExportButton
                id='inversores-export-button'
                name='inversores-export-button'
                serverDownload={() => PaisesApi.export({ filter: filterValues })}
                getFileName={() => 'nacionalidades.csv'}
                postDownloading={() =>
                  addNotification({
                    message: 'Se descargo archivo de Nacionalidades',
                    type: 'info',
                  })
                }
              />
            }
          />
        </div>

        <BymaDataTable
          key='paises'
          columns={getPaisColumns(context)}
          sizeColumnsToFit={true}
          style={{ height: '310px', width: '100%' }}
          queryProps={{
            dataProvider: dataProvider,
            listKey: context.listQueryKey,
          }}
          listPaginationProps={{
            showLimits: true,
          }}
          //suppressHorizontalScroll={true}
        />
      </BymaCard>

      <PaisModal
        navigateTo='/nacionalidades'
        context={context}
        api={PaisesApi}
        formId='colocador-form'
      />
    </BymaPageFrame>
  )
}

const PaisList = () => {
  return (
    <LoadingProvider>
      <ListBase
        listKey='pais.hist'
        filterDefaultValues={{ [SORT_FILTER_NAME]: OrdenPais.DENOMINACION_ASC }}
      >
        <PaisTable />
      </ListBase>
    </LoadingProvider>
  )
}

export default PaisList
